import Vue from 'vue'
import axios from 'axios'
import router from '../router'

export const api = {
    state: {
        advice: null,
        status: 'init',
        adviceStatus: null,
        token: '',
        suppliersPosition: {},
        recipientsPosition: {}
    },
    mutations: {
        SET_STATUS(state, status){
            state.status = status
        },
        SET_ADVICE_STATUS(state, adviceStatus){
            state.adviceStatus = adviceStatus
        },
        SET_CONTENT(state, advice) {
            state.advice = advice
        },
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_POSITION_SUPPLIERS(state, payload) {
            state.suppliersPosition = payload
        },
        SET_POSITION_RECIPIENTS(state, payload) {
            state.recipientsPosition = payload
        }
    },
    actions: {
        fetchContent({ commit, dispatch }, payload){
            commit('SET_STATUS', 'loading')
            return axios.get(`${process.env.VUE_APP_API}api/advices/${payload}`)
            .then((response) => {
                commit('SET_CONTENT', Object.freeze(response.data.data.advice))
                commit('SET_STATUS', 'idle')
                commit('SET_TOKEN', payload)
                commit('SET_ADVICE_STATUS', response.data.data.advice.status_symbol)

                dispatch('geolocate', 'suppliers').then(() => {
                    dispatch('geolocate', 'recipients')
                })
            }).catch(e => {
                console.log(e);
                router.push({ name: 'empty' })
            })
        },
        geolocate({ state, commit }, payload) {
            if(state.advice[payload].latitude !== null && state.advice[payload].longitude !== null) {
                // get lat lang from api
                commit(`SET_POSITION_${payload.toUpperCase()}`, {
                    lat: state.advice[payload].latitude,
                    lng: state.advice[payload].longitude
                })
            } else {
                // else use geocoding
                const addressObj = {
                    address_line_1: state.advice[payload].address,
                    city:           state.advice[payload].city,
                    zip_code:       state.advice[payload].postcode,
                    country:        state.advice[payload].country ? state.advice[payload].country : 'Poland'
                }
                Vue.$geocoder.send(addressObj, response => {
                    if(response.status === 'OK'){
                        commit(`SET_POSITION_${payload.toUpperCase()}`, {
                            lat: response.results[0].geometry.location.lat,
                            lng: response.results[0].geometry.location.lng
                        })
                    } else {
                        commit(`SET_POSITION_${payload.toUpperCase()}`, null)
                    }
                })
            }
        },
        submitLoading({ state, getters, commit }){
            if(state.token) {
                commit('SET_STATUS', 'sending')
                return axios.post(`${process.env.VUE_APP_API}api/advices/loading`, {
                    token: getters.token,
                    images: getters.loadingPhotosForApi,
                    status: 'received'
                })
                .then(response => {
                    console.log(response);
                }).catch(e => {
                    console.log(e)
                    commit('SET_STATUS', 'loadingSentError')
                })
            } else {
                console.error('Brak prawidłowego tokenu')
            }
        },
        submitUnloading({ state, getters, commit }, payload){
            if(state.token) {
                commit('SET_STATUS', 'sending')
                return axios.post(`${process.env.VUE_APP_API}api/advices/unloading`, {
                    token: getters.token,
                    images: getters.unloadingPhotosForApi,
                    status: payload.status,
                    message: payload.message
                })
                .then(response => {
                    console.log(response);
                }).catch(e => {
                    console.log(e)
                    commit('SET_STATUS', 'loadingSentError')
                    return Promise.reject(e.message)
                })
            } else {
                console.error('Brak prawidłowego tokenu')
            }
        }
    },
    getters : {
        status: (state) => {
            return state.status
        },
        adviceStatus: (state) => {
            return state.adviceStatus
        },
        advice: (state) => {
            return state.advice
        },
        token: (state) => {
            return state.token
        },
        suppliersPosition: (state) => {
            return state.suppliersPosition
        },
        recipientsPosition: (state) => {
            return state.recipientsPosition
        }
    }
}
